function ClashRoyaleNotice() {
  return <h1>미정</h1>;
}

export default ClashRoyaleNotice;
